import Immutable from 'seamless-immutable'
import { USER_DEFAULT_TYPE } from '../../../constants/bussinesCode'
import * as types from './types'

export const INITIAL_STATE = Immutable({
  fetching: false,
  received: false,
  profile: null,
  roles: [],
  dashboards: [],
  acceptedCommitmentTermAt: null,
  acceptedResponsibilityTermAt: null,
  businessCode: USER_DEFAULT_TYPE
})

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.RECEIVE_ROLES: {
      return state.setIn(['roles'], action.payload)
    }

    case types.RECEIVE_DASHBOARDS: {
      return state.setIn(['dashboards'], action.payload)
    }

    case types.FETCH_PROFILE: {
      return state.setIn(['fetching'], true)
    }

    case types.RECEIVE_PROFILE: {
      return state.setIn(['fetching'], false).setIn(['profile'], action.payload)
    }

    case types.RECEIVE_TERMS: {
      const { acceptedCommitmentTermAt, acceptedResponsibilityTermAt } =
        action.payload
      return state
        .setIn(['acceptedCommitmentTermAt'], acceptedCommitmentTermAt)
        .setIn(['acceptedResponsibilityTermAt'], acceptedResponsibilityTermAt)
    }

    case types.RECEIVE_BUSSINES_CODE: {
      return state.setIn(['businessCode'], action.payload)
    }

    case types.CLEAR_ALL: {
      return state.set(INITIAL_STATE)
    }

    default: {
      return state
    }
  }
}

export default reducer
